export default __webpack_public_path__ + "static/media/health_icon.0ecff904.svg";